module.exports = __webpack_public_path__ + "img/df345ec.jpg";